module.exports = __webpack_public_path__ + "media/images/dashbard4_2-58330b9916ca6286f6e88b0f8246977d.jpg";